import React, { useEffect, useState } from "react";
import PageContainer from "../../components/PageContainer";
import { PlusOutlined } from "@ant-design/icons";
import {
  getBankGatewayService,
  getWalletBalanceService,
  getWalletTransactionsService,
  handlePaymentService,
} from "./transactions.api";
import { Button, Col, InputNumber, message, Row, Select, Skeleton } from "antd";
import TransactionItem from "./TransactionItem";
import { useParams } from "react-router-dom";
import BottomSheet from "../../components/BottomSheet";
import { checkValue, convertNumToFa } from "../../constant/helper";

const Transactions = () => {
  const { sessionId } = useParams();

  const [paymentLoading, setPaymentLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [balance, setBalance] = useState(0);
  const [list, setList] = useState([]);
  const [resetList, setResetList] = useState(false);
  const [filter, setFilter] = useState({
    sort: "DESC",
    sortKey: "createdDate",
  });
  // eslint-disable-next-line
  const [meta, setMeta] = useState({});
  const [pathname, setPathname] = useState("");
  const [paymentPopup, setPaymentPopup] = useState(false);
  const [bankGateways, setBankGateways] = useState([]);
  const [paymentForm, setPaymentForm] = useState({
    amount: "",
    clientCallbackUrl: window.location.href,
    bankGatewayId: "",
    // description: "created by PWA-Client",
    walletTransactionType: "DEPOSIT",
  });
  const [pageNumber, setPageNumber] = useState(0);
  const [showLoadMore, setShowLoadMore] = useState(true);

  useEffect(() => {
    fetchBalance();
    fetchBankGatewayList();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (sessionId) {
      let sessionData = sessionStorage.getItem(sessionId);
      if (sessionData) {
        sessionData = JSON.parse(sessionData);

        let amount = Number(sessionData.price);

        if (amount < 10_000) {
          amount = 10_000;
        }

        setPaymentForm({
          ...paymentForm,
          amount,
          // clientCallbackUrl: `${
          //   window.location.protocol +
          //   "//" +
          //   window.location.hostname +
          //   sessionData.pathname
          // }`,
        });
        setPathname(sessionData.pathname);
        setPaymentPopup(true);
      }
    }
    // eslint-disable-next-line
  }, [sessionId, bankGateways]);

  useEffect(() => {
    if (bankGateways && bankGateways.length > 0 && !paymentForm.bankGatewayId) {
      handleChangePaymentForm(bankGateways[0]["id"], "bankGatewayId");
    }
    // eslint-disable-next-line
  }, [bankGateways]);

  useEffect(() => {
    setPageNumber(0);
    setResetList(true);
  }, [filter]);

  useEffect(() => {
    if (pageNumber > 0) {
      fetchTransactionsList();
    }
    // eslint-disable-next-line
  }, [pageNumber]);

  useEffect(() => {
    if (resetList) {
      fetchTransactionsList();
      setResetList(false);
    }
    // eslint-disable-next-line
  }, [resetList]);

  function fetchBalance() {
    getWalletBalanceService()
      .then((resp) => {
        const { balance } = resp.data;
        setBalance(balance);
      })
      .catch((err) => {
        message.error("دریافت مقدار موجودی با خطا مواجه شد!");
      });
  }

  function fetchTransactionsList() {
    setLoading(true);

    getWalletTransactionsService({
      pageNumber: pageNumber,
      pageSize: 20,
      ...filter,
    })
      .then((resp) => {
        const { content, ...metaData } = resp.data;

        if (pageNumber === 0) {
          setList(content);
        } else if (content) {
          setList([...list, ...content]);
        }

        if (
          resp.data &&
          // resp.data.numberOfElements === 0 &&
          // resp.data.empty === true &&
          resp.data.last === true
        ) {
          setShowLoadMore(false);
        } else {
          setShowLoadMore(true);
        }

        setMeta(metaData);
        setLoading(false);
      })
      .catch((error) => {
        message.error("دریافت تراکنش ها با خطا مواجه شد!");
        setLoading(false);
      });
  }

  function fetchBankGatewayList() {
    getBankGatewayService()
      .then((resp) => {
        const { content } = resp.data;
        setBankGateways(content);

        if (content.length > 0) {
          setPaymentForm({
            ...paymentForm,
            bankGatewayId: content[0]["id"],
          });
        }
      })
      .catch((error) => {
        message.error("دریافت لیست بانک ها با خطا مواجه شد!");
        setLoading(false);
      });
  }

  function handleChangeFilter(value) {
    setFilter({ ...filter, sort: value });
  }

  function handleChangePaymentForm(value = "", prop = "price") {
    setPaymentForm({ ...paymentForm, [prop]: value });
  }

  function handlePayment() {
    if (!checkValue(paymentForm.amount) || isNaN(paymentForm.amount)) {
      message.error("مبلغ وارد شده اشتباه است");
      return;
    }

    if (paymentForm.amount < 10000) {
      message.error("مبلغ وارد شده باید بالاتر از ۱۰۰۰۰ ریال باشد");
      return;
    }

    setPaymentLoading(true);
    handlePaymentService(paymentForm)
      .then((resp) => {
        const { paymentLink } = resp.data;
        setPaymentPopup(false);
        setPaymentForm({
          amount: 0,
          bankGatewayId: "",
          // description: "created by PWA-Client",
          paymentLink: window.location.href,
          walletTransactionType: "DEPOSIT",
        });
        message.loading("در حال انتقال به صفحه پرداخت");
        window.location.href = paymentLink;
      })
      .catch((error) => {
        message.error("خطا در عملیات پرداخت");
      })
      .finally(() => {
        setPaymentLoading(false);
      });
  }

  return (
    <PageContainer
      headerProps={{
        link:
          pathname && pathname !== window.location.pathname
            ? pathname
            : "/menu",
        right: "",
        content: "صورت حساب و افزایش اعتبار",
        className: "home-header-holder transactions-header-holder",
        children: (
          <>
            <div className={"home-header transactions-header center-flex"}>
              <div className="credit">
                اعتبار:
                <span className="price">
                  {balance
                    ? convertNumToFa(balance.toLocaleString("fa"))
                    : convertNumToFa("0")}
                </span>
                ریال
              </div>
            </div>
            <div className="footer-icon" onClick={() => setPaymentPopup(true)}>
              <PlusOutlined />
            </div>
          </>
        ),
        tall: true,
      }}
      classNames={"transactions"}
    >
      <div className="title center-text">
        لیست <span className={"black-text"}> تراکنش ها </span>
      </div>
      {/* <div className="count center-text">
        مجموع تراکنش ها: {meta && meta.totalElements ? meta.totalElements : "-"}
      </div> */}
      <div className="filter center-flex mt-3">
        <div className="temp"> تراکنش</div>
        <div className="lawone-selector">
          <Select
            value={filter.sort}
            onChange={handleChangeFilter}
            placeholder={"انتخاب کنید"}
            size="small"
          >
            <Select.Option value="">بدون فیلتر</Select.Option>
            <Select.Option value="ASC">صعودی</Select.Option>
            <Select.Option value="DESC">نزولی</Select.Option>
          </Select>
        </div>
      </div>
      <div className="list">
        {list &&
          list.length > 0 &&
          list.map((item, index) => (
            <TransactionItem item={item} index={index} key={index} />
          ))}

        {loading && (
          <>
            <div className="transaction">
              <Skeleton
                active={true}
                avatar={{ shape: "circle" }}
                title={{ width: "50%" }}
                paragraph={false}
              />
            </div>
            <div className="transaction mt-3">
              <Skeleton
                active={true}
                avatar={{ shape: "circle" }}
                title={{ width: "50%" }}
                paragraph={false}
              />
            </div>
            <div className="transaction mt-3">
              <Skeleton
                active={true}
                avatar={{ shape: "circle" }}
                title={{ width: "50%" }}
                paragraph={false}
              />
            </div>
            <div className="transaction mt-3">
              <Skeleton
                active={true}
                avatar={{ shape: "circle" }}
                title={{ width: "50%" }}
                paragraph={false}
              />
            </div>
            <div className="transaction mt-3">
              <Skeleton
                active={true}
                avatar={{ shape: "circle" }}
                title={{ width: "50%" }}
                paragraph={false}
              />
            </div>
          </>
        )}

        {!loading && showLoadMore && (
          <div className="submit-btn center-flex mb-20">
            <Button
              type="text"
              className="load-more-btn"
              onClick={() => setPageNumber(pageNumber + 1)}
            >
              بارگذاری بیشتر
            </Button>
          </div>
        )}
      </div>

      <BottomSheet
        setClose={() => setPaymentPopup(false)}
        isOpen={paymentPopup}
        classNames={"payment-popup-transactions"}
        viewerClassName={"payment-popup-transactions-viewer right-text"}
      >
        <Row justify="center">
          <Col span={18}>
            <h3> افزایش اعتبار حساب کاربری (ریال) </h3>
            <div className="center-text">
              <div className={"mt-3"}>
                <InputNumber
                  className="input-hide-arrows"
                  placeholder={"مبلغ افزایش اعتبار"}
                  defaultValue={paymentForm.amount}
                  value={paymentForm.amount}
                  min={1}
                  onChange={(value) => {
                    handleChangePaymentForm(Number(value), "amount");
                  }}
                  formatter={(value) =>
                    `${!isNaN(Number(value)) ? value : ""}`.replace(
                      /\B(?=(\d{3})+(?!\d))/g,
                      ","
                    )
                  }
                  parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                />
              </div>

              <div className={"mt-3"}>
                <Select
                  size="large"
                  value={paymentForm.bankGatewayId}
                  onChange={(value) => {
                    handleChangePaymentForm(value, "bankGatewayId");
                  }}
                >
                  {bankGateways &&
                    bankGateways.map((i) => (
                      <Select.Option value={i.id} key={i.id}>
                        {i.name ? i.name : i.type}
                      </Select.Option>
                    ))}
                </Select>
              </div>
              <div className={"submit-btn mt-3"}>
                <Button
                  type="primary"
                  onClick={handlePayment}
                  loading={paymentLoading}
                  disabled={paymentLoading}
                >
                  پرداخت
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </BottomSheet>
    </PageContainer>
  );
};

export default Transactions;
